import { Box, styled } from "@mui/material";

const MainContainer = styled(Box)(({ theme }) => ({
  display: "grid",
  gridTemplateColumns: "1fr",

  paddingTop: "32px",
  paddingBottom: "32px",
  gap: "32px",

  alignItems: "start",

  [theme.breakpoints.up("md")]: {
    gap: "72px",
    gridTemplateColumns: "1fr",
  },

  [theme.breakpoints.up("lg")]: {
    gap: "72px",
    gridTemplateColumns: "60ch auto",
  },

  [theme.breakpoints.up("xl")]: {
    gap: "72px",
    gridTemplateColumns: "75ch auto",
  },
}));

const ServiceFormContainer = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up("lg")]: {
    position: "sticky",
    top: "128px",
    bottom: "-1px",
    height: "auto",
  },

  "@media (min-width: 1228px)": {
    position: "sticky",
    top: "106px",
    bottom: "-1px",
    height: "auto",
  },
}));

const ServiceCardsContainer = styled(Box)(({ theme }) => ({
  width: "calc(100vw - 48px)",

  display: "flex",
  gap: "20px",

  overflow: "scroll",

  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },

  [theme.breakpoints.up("md")]: {
    width: "100%",
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(175px, 1fr))",
    gap: "20px",
  },
}));

const DocumentationCardsContainer = styled(Box)(({ theme }) => ({
  width: "100%",
  maxWidth: "100vw",

  display: "flex",
  gap: "20px",

  overflow: "scroll",
  alignItems: "stretch",

  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },

}));

export {
  MainContainer,
  ServiceFormContainer,
  ServiceCardsContainer,
  DocumentationCardsContainer,
};
